<template>
    <div>
        <v-card
                @click.stop
                :ripple="false"
                class="mx-auto"
                max-width="550"
                outlined>
        <v-card-text>
            <v-list two-line>
                <v-list-item-group
                        multiple
                >
                        <template v-for="(item, index) in notifications">
                            <transition-group name="fade-in" mode="out-in">
                                <v-list-item :key="item.id" @click="handleClick(item)">
                                    <template v-slot:default="{ active, toggle }">
                                        <v-list-item-content>
                                            <v-list-item-subtitle class="text--primary" v-text="item.content"></v-list-item-subtitle>
                                        </v-list-item-content>

                                        <v-list-item-action>
                                            <v-btn @click.stop="markAsRead(item)" icon color="primary" outlined><v-icon>mdi-eye</v-icon></v-btn>
                                        </v-list-item-action>
                                    </template>
                                </v-list-item>
                            </transition-group>
                        </template>
                </v-list-item-group>
                <v-list-item v-if="notifications.length == 0">
                    <p>{{$t('Nie znaleziono nowych powiadomień')}}</p>
                </v-list-item>
            </v-list>
            <v-btn block class="ma-0" to="/notifications" depressed>See all</v-btn>
        </v-card-text>
     </v-card>
    </div>

</template>

<script>
    import {editBread} from "../api/bread";

    export default {
        data: () => ({

        }),
        computed:{
            notifications(){
                var data = this.$store.getters.notifications;
                if(data){
                    return data.notifications.filter(item => {
                        return item.seen == 0;
                    })
                }
                return [];
            }
        },
        methods:{
            handleClick(item){
                if(item.link){
                    this.$router.push(item.link);
                }
            },
            markAsRead(notification){
                notification.seen = true
                var data = notification;
                editBread('Notification', data, notification.id).then(response => {
                    this.$store.commit('notifications/SET_NOTIFICATION', response);
                    this.$store.commit('notifications/DECREMENT_UNSEEN');
                })
            }
        }
    }
</script>
